<div class="notification-modal-container" [ngClass]="cssClass">
  <div
    class="modal-header d-flex flex-column align-items-center ms-auto c-mtm-brand"
    [ngClass]="{ 'justify-content-center': centerHeader, 'no-header-border': noHeaderBorder }">
    @if (title) {
      <h4 class="modal-title">{{ title }}</h4>
    }
    @if (title2) {
      <h4 class="c-mtm-black modal-title2 mb-0 mt-3">{{ title2 }}</h4>
    }
    <button
      type="button"
      [hidden]="isCloseButtonHidden"
      class="m-0 p-0 btn-close"
      aria-label="Close"
      (click)="onCancelModal('closedButton')">
    </button>
  </div>
  <div class="modal-body notification-modal-body">
    @if (icon) {
      <div class="d-flex align-items-center justify-content-center">
        @if (icon === 'warning') {
          <div class="modal-icon">
            <img ngSrc="/assets/img/annotations/warning_icon.png" alt="" height="{{ iconSize || 24 }}" />
          </div>
        }
        @if (icon === 'file-confirm') {
          <div class="modal-icon">
            <img ngSrc="/assets/img/icons/file-confirm.svg" alt="" height="{{ iconSize || 24 }}" />
          </div>
        }
      </div>
    }
    <div class="container">
      <div class="d-block">
        @if (description) {
          <div class="description mb-3 c-mtm-black desc1">{{ description }}</div>
        }
        @if (description3) {
          <div class="description mb-3 c-mtm-black desc3" [innerHTML]="description3"></div>
        }
        @if (description2) {
          <div class="description mb-3 c-mtm-black desc2">{{ description2 }}</div>
        }
        @if (notificationInfo) {
          <div class="notification-info mb-3 c-mtm-purple" [innerHTML]="notificationInfo"></div>
        }
        @if (question) {
          <div class="notification-question _600 mb-3 c-mtm-black" [innerHTML]="question"></div>
        }
        @if (question2) {
          <div class="notification-question mb-3 c-mtm-black">{{ question2 }}</div>
        }
        @if (descriptionMeta) {
          <div class="description-meta mb-3 c-mtm-black">
            {{ descriptionMeta }}
          </div>
        }
        @if (noteInfo) {
          <div class="note-info mb-3 c-mtm-black" [innerHTML]="noteInfo"> </div>
        }

        <div class="d-flex flex-column flex-sm-row align-items-center justify-content-center mt-4 buttons">
          @if (cancelBtn) {
            <button
              type="button"
              class="btn b-mtm-grey c-mtm-purple t-uppercase _600 btn-cancel"
              (click)="onCancelModal('cancel')"
              >{{ cancelBtn }}</button
            >
          }
          @if (confirmBtn) {
            <button
              type="button"
              [ngClass]="{
                'b-mtm-green': notificationType === 'success',
                'b-mtm-red': notificationType === 'danger',
                'b-mtm-brand': !notificationType,
              }"
              class="btn c-full-white t-uppercase _600 btn-confirm"
              (click)="onConfirmModal()"
              >{{ confirmBtn }}</button
            >
          }
        </div>
      </div>
    </div>
  </div>
</div>
